import { Component, Vue } from 'vue-property-decorator'
import HighFilter from '@/components/highFilter/index.vue'
import { queryDirectorList } from '@/api'
@Component({ name: 'TeamList', components: { HighFilter } })
export default class TeamList extends Vue {
  private tableData: any = []
  private currentPage = 1
  private totalPage = 1
  private filterData: any = {};
  private filterResult: any = null
  private showHighFilter = false
  private tableloading: any =false
  created () {
    this.initPageData()
  }

  private async initPageData () {
    const param: any = { page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await queryDirectorList(param)
    this.currentPage = result.currentPage
    this.totalPage = result.allPage
    this.tableData = result.teacherList
    this.filterData = result.search
  }

  //
  private onPageChange (page: any) {
    this.currentPage = page
    this.initPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }

  private rowClicked (row: any) {
    this.$router.push({ path: '/operate/team_list_detail', query: { id: row.id } })
  }
}
